/* WHOOSH! landing sections — shared behaviour.
   Loaded (and possibly executed) once per section; every init is
   idempotent via data-wh-init guards and re-runs on Shopify
   section editor events. */
(function () {
  "use strict";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveals(root) {
    var els = root.querySelectorAll(".wh-reveal:not([data-wh-init])");
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("wh-in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) {
      el.setAttribute("data-wh-init", "1");
      io.observe(el);
    });
  }

  function initCounters(root) {
    var els = root.querySelectorAll(".wh-count:not([data-wh-init])");
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var to = parseInt(el.getAttribute("data-to"), 10) || 0;
        if (reduced) { el.textContent = to; return; }
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 1400, 1);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) {
      el.setAttribute("data-wh-init", "1");
      io.observe(el);
    });
  }

  function initCarousels(root) {
    root.querySelectorAll("[data-wh-carousel]:not([data-wh-init])").forEach(function (wrap) {
      wrap.setAttribute("data-wh-init", "1");
      var track = wrap.querySelector(".wh-prods__track");
      if (!track) return;
      function step() {
        var c = track.querySelector(".wh-prod");
        return c ? c.offsetWidth + 22 : 320;
      }
      var prev = wrap.querySelector("[data-wh-prev]");
      var next = wrap.querySelector("[data-wh-next]");
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    });
  }

  function initParallax(root) {
    if (reduced || !window.matchMedia("(pointer:fine)").matches) return;
    root.querySelectorAll("[data-wh-parallax-zone]:not([data-wh-init])").forEach(function (zone) {
      zone.setAttribute("data-wh-init", "1");
      var targets = zone.querySelectorAll("[data-parallax]");
      if (!targets.length) return;
      var rx = 0, ry = 0, cx = 0, cy = 0, raf = null;
      function tick() {
        cx += (rx - cx) * 0.08;
        cy += (ry - cy) * 0.08;
        targets.forEach(function (t) {
          var d = parseFloat(t.getAttribute("data-parallax"));
          t.style.translate = (cx * d) + "px " + (cy * d) + "px";
        });
        if (Math.abs(rx - cx) > 0.001 || Math.abs(ry - cy) > 0.001) raf = requestAnimationFrame(tick);
        else raf = null;
      }
      zone.addEventListener("mousemove", function (ev) {
        var r = zone.getBoundingClientRect();
        rx = (ev.clientX - r.left) / r.width - 0.5;
        ry = (ev.clientY - r.top) / r.height - 0.5;
        if (!raf) raf = requestAnimationFrame(tick);
      });
      zone.addEventListener("mouseleave", function () {
        rx = 0; ry = 0;
        if (!raf) raf = requestAnimationFrame(tick);
      });
    });
  }

  function initAll() {
    initReveals(document);
    initCounters(document);
    initCarousels(document);
    initParallax(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();
